import { css } from 'styled-components';
import { spacing as globalSpacing } from '../../../style/spacing';
import { colors } from '../../../style';

export const spacing = {
  none: globalSpacing.none,
  xxs: globalSpacing.xxs,
  xs: globalSpacing.xs,
  sm: globalSpacing.sm,
  md: globalSpacing.md,
  lg: globalSpacing.lg,
  xl: globalSpacing.xl,
};

export const tableCellVariants = {
  'positive-background-border-bottom': css`
    background-color: ${colors.positiveBackground};
    border-bottom: 1px solid ${colors.gray300};
  `,
  'light-teal-background': css`
    background-color: ${colors.lightTeal};
    border-bottom: 1px solid ${colors.gray300};
  `,
  'teal-background': css`
    background-color: ${colors.teal};
    border-bottom: 1px solid ${colors.gray300};
  `,
  'carribean-blue-background': css`
    background-color: #14beca;
    border-bottom: 1px solid ${colors.gray300};
  `,
  'border-left': css`
    background-color: white;
    border-left: 1px solid ${colors.gray300};
  `,
  'border-right': css`
    background-color: white;
    border-right: 1px solid ${colors.gray300};
  `,
  gray100: css`
    background-color: ${colors.gray100};
  `,
  'light-violet': css`
    background-color: ${colors.violet};
  `,
  'violet-lightest': css`
    background-color: #e5e7fb;
    border-bottom: 1px solid ${colors.gray300};
  `,
  'violet-light': css`
    background-color: #c7ccff;
    border-bottom: 1px solid ${colors.gray300};
  `,
  'violet-medium': css`
    background-color: #a5acff;
    border-bottom: 1px solid ${colors.gray300};
  `,
  'violet-dark': css`
    background-color: #818cf8;
    border-bottom: 1px solid ${colors.gray300};
  `,
  'violet-darkest': css`
    background-color: #6366f1;
    border-bottom: 1px solid ${colors.gray300};
  `,
  white: css`
    background-color: ${colors.white};
  `,
};
